export enum SavedViewEditableFields {
  None,
  Name,
  IsPublic,
}
